import { createContext, useContext } from "react";
import { processImage } from "../../../mobile/src/features/Image/processImage";
import { Upload } from "../../../mobile/src/OS/ImageUploadProvider";

export const UploadContext = createContext<{
  uploads: Upload[];

  prepareForImageUpload: (args: {
    width: number;
    height: number;
    localImageURI: string;
    processImageActions?: Parameters<typeof processImage>[1];
    imageId?: string;
  }) => Promise<string>;
  uploadImage: (args: {
    imageId: string;
    uploadURL: string;
    uploadId: string;
  }) => Promise<void>;
}>({
  uploads: [],
  prepareForImageUpload: () => {
    throw new Error("Not implemented");
    return Promise.resolve("");
  },
  uploadImage: () => Promise.resolve(),
});

export const useUploadedImages = () => {
  return useContext(UploadContext).uploads;
};
export const useUploadImage = () => {
  const ctx = useContext(UploadContext);
  return {
    uploadImage: ctx.uploadImage,
    prepareForImageUpload: ctx.prepareForImageUpload,
  };
};
